"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OTHER_LIST_SID = exports.WATCH_LIST_SID = exports.NEW_LIST_SID = exports.SESSION_STORAGE = void 0;
exports.SESSION_STORAGE = {
    EXPIRY_TIME_OFFSET: 30,
    SESSION_KEY_NAME: 'add_to_list_Data',
};
exports.NEW_LIST_SID = 'p4534336.m170678.l187538';
exports.WATCH_LIST_SID = 'p4534336.m163179.l180878';
exports.OTHER_LIST_SID = 'p4534336.m163179.l170168';
